<template>
  <section class="page-market-buy">
    <div v-if="!loading || product">
      <b-row>
        <b-col
          class="d-flex align-items-center my-1"
          sm="12"
        >
          <div class="back-button cursor-pointer mr-2">
            <router-link :to="{ name: isDynamicMarket ? 'market-dynamic' : 'market' }">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                size="lg"
                style="color: #fff;"
              />
            </router-link>
          </div>
          <h2 class="page-title">
            {{ $t('Secure payment') }}
          </h2>
        </b-col>
      </b-row>
      <b-alert v-if="dynamicError" variant="danger" show>{{ dynamicError }} <router-link :to="{ name: 'market-dynamic' }">{{ dynamicCopy.back }}</router-link></b-alert>
      <b-overlay
        :show="loading"
        no-center
        variant="transparent"
        rounded="sm"
      >
        <template #overlay>
          <loading-spinner />
        </template>
        <div
          v-if="product"
          class="payment-package-details"
        >
          <div class="package-left">
            <b-img
              :src="iconDiamonds1"
              width="38"
            />
          </div>
          <div class="package-right">
            <div class="package-name">
              {{ numberFormat(product.credits) }}
              {{ minCredits <= product.credits && couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
              {{ $t('Diamonds') }}
              <span>
                | {{ currencySymbol(product.currency) }} {{ product.amount }}
              </span>
            </div>
            <div class="package-description">
              {{ $t('By buying {count} diamonds, you will start chatting as you wish', {count:numberFormat(product.credits)}) }}
            </div>
            <div v-if="dynamicOffer" class="package-description">
              {{ dynamicCopy.photo }}: {{ dynamicOffer.photoAllowance }} · {{ dynamicCopy.video }}: {{ dynamicOffer.videoAllowance }} · {{ dynamicCopy.bonus }}: +{{ numberFormat(dynamicOffer.bonusCredits) }}
            </div>
          </div>
        </div>
        <b-row v-if="loading || product">
          <b-col
            md="12"
            sm="12"
          >
            <b-row>
              <b-col md="12">
                <h3 class="h3">
                  {{ $t('Payment methods') }}
                </h3>
              </b-col>
              <b-col
                xl="10"
                lg="12"
                md="12"
              >
                <div
                  class="accordion buying-options"
                  role="tablist"
                >
                  <div
                    id="option-credit-card"
                    class="buying-option"
                  >
                    <div
                      v-b-toggle.accordion-1
                      class="buying-option-header"
                      role="tab"
                      @click="scrollTo('option-credit-card')"
                    >
                      <div>
                        {{ $t('Pay with card') }} ({{ $t('Credit/Debit Card') }})
                      </div>
                      <div class="fs-14 color-gray fw-300">
                        {{ $t('You can pay securely with all debit and credit cards') }}
                      </div>
                      <span class="badge-advantage">
                        {{ $t('Most advantageous') }}
                      </span>
                    </div>
                    <b-collapse
                      id="accordion-1"
                      accordion="my-accordion"
                      role="tabpanel"
                      :visible="true"
                    >
                      <!-- :visible="campaignType === 'ONE_TIME_OFFER' || (product.currency !== 'TRY')" -->
                      <div
                        v-if="paymentGateway === 'craftgate'"
                        class="buying-option-body"
                      >
                        <validation-observer
                          ref="formCraftgate"
                          #default="{}"
                        >
                          <b-form
                            class="mt-2"
                            @submit.prevent
                          >
                            <b-row>
                              <b-col
                                xl="4"
                                lg="4"
                                md="5"
                                sm="12"
                              >
                                <div class="market-banner-mobile">
                                  <div class="market-banner-mobile-inner">
                                    <b-img
                                      :src="require('@/assets/images/icons/diamonds-3-new-3.svg')"
                                      width="74"
                                      height="72"
                                    />
                                    {{ $t('You can continue chatting by purchasing {count} diamonds!', {count: numberFormat(product.credits)}) }}
                                  </div>
                                </div>
                                <div class="market-banner-desktop">
                                  <b-img :src="require('@/assets/images/icons/diamonds-3-new-3.svg')" />
                                  <div class="market-banner-desktop-inner">
                                    <p>
                                      <b>
                                        {{ $t('Buy diamonds, enjoy the conversation and the fun') }}!
                                      </b>
                                    </p>
                                    <p>
                                      <span style="font-size: 18px; color: #EC065B;">
                                        {{ numberFormat(product.credits) }}
                                        {{ minCredits <= product.credits && couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
                                        {{ $t('Diamonds') }}
                                      </span>
                                    </p>
                                    <p>
                                      <span style="font-size: 14px;">
                                        {{ currencySymbol(product.currency) }}{{ product.amount }}
                                      </span>
                                    </p>
                                    <p>
                                      {{ $t('You can continue chatting by purchasing {count} diamonds!', {count: numberFormat(product.credits)}) }}
                                    </p>
                                  </div>
                                  <div class="market-banner-desktop-footer">
                                    <a
                                      :href="locale === 'tr' ? 'https://boholive.app/tr/uye-sozlesmesi' : 'https://boholive.app/terms-of-service'"
                                      target="_blank"
                                    >
                                      {{ $t('Terms') }}
                                    </a>
                                    <a
                                      :href="locale === 'tr' ? 'https://boholive.app/tr/gizlilik-ve-kullanim-kosullari' : 'https://boholive.app/membership-agreement'"
                                      target="_blank"
                                    >
                                      {{ $t('Privacy and Terms of Use') }}
                                    </a>
                                    <a
                                      v-if="locale === 'tr'"
                                      href="https://boholive.app/tr/kisisel-verilerin-korunmasi-politikasi"
                                      target="_blank"
                                    >
                                      {{ $t('KVKK') }}
                                    </a>
                                  </div>
                                </div>
                              </b-col>
                              <b-col
                                xl="6"
                                lg="6"
                                md="7"
                                sm="12"
                              >
                                <b-row>
                                  <b-col
                                    v-if="product && product.credits >= 0 && !isDynamicMarket"
                                    sm="12"
                                  >
                                    <b-form-group
                                      label-for="coupon-code"
                                      :label="$t('Coupon Code')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Coupon Code')"
                                        vid="number"
                                        rules="min:4"
                                      >
                                        <b-row>
                                          <b-col sm="12">
                                            <b-input-group>
                                              <b-form-input
                                                v-model="couponCode"
                                                style="border-bottom-right-radius: 0 !important; border-top-right-radius: 0 !important;"
                                                name="couponCode"
                                                :disabled="couponCodeSucceed"
                                                :placeholder="$t('Enter Your Coupon')"
                                              />
                                              <b-input-group-append>
                                                <b-button
                                                  size="sm"
                                                  variant="success"
                                                  :disabled="couponCodeSucceed || loading || couponCode.length < 4"
                                                  @click="applyCouponCode"
                                                >
                                                  {{ $t('Use Coupon') }}
                                                </b-button>
                                              </b-input-group-append>
                                            </b-input-group>
                                            <div
                                              class="mt-05 fs-11 color-black fw-400"
                                              :class="couponCodeInfoColor"
                                            >
                                              <svg
                                                width="19"
                                                height="19"
                                                viewBox="0 0 19 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M9.16667 1.83333C7.22175 1.83333 5.35649 2.60595 3.98122 3.98122C2.60595 5.35649 1.83333 7.22175 1.83333 9.16667C1.83333 11.1116 2.60595 12.9769 3.98122 14.3521C5.35649 15.7274 7.22175 16.5 9.16667 16.5C11.1116 16.5 12.9769 15.7274 14.3521 14.3521C15.7274 12.9769 16.5 11.1116 16.5 9.16667C16.5 7.22175 15.7274 5.35649 14.3521 3.98122C12.9769 2.60595 11.1116 1.83333 9.16667 1.83333ZM0 9.16667C0 4.10392 4.10392 0 9.16667 0C14.2294 0 18.3333 4.10392 18.3333 9.16667C18.3333 14.2294 14.2294 18.3333 9.16667 18.3333C4.10392 18.3333 0 14.2294 0 9.16667ZM9.16667 13.75C9.40979 13.75 9.64294 13.6534 9.81485 13.4815C9.98676 13.3096 10.0833 13.0765 10.0833 12.8333V9.16667C10.0833 8.92356 9.98676 8.6904 9.81485 8.51849C9.64294 8.34658 9.40979 8.25 9.16667 8.25C8.92356 8.25 8.6904 8.34658 8.51849 8.51849C8.34658 8.6904 8.25 8.92356 8.25 9.16667V12.8333C8.25 13.0765 8.34658 13.3096 8.51849 13.4815C8.6904 13.6534 8.92356 13.75 9.16667 13.75ZM9.16667 4.58334C8.92356 4.58334 8.6904 4.67991 8.51849 4.85182C8.34658 5.02373 8.25 5.25689 8.25 5.5C8.25 5.74312 8.34658 5.97628 8.51849 6.14818C8.6904 6.32009 8.92356 6.41667 9.16667 6.41667H9.17584C9.41895 6.41667 9.65211 6.32009 9.82402 6.14818C9.99593 5.97628 10.0925 5.74312 10.0925 5.5C10.0925 5.25689 9.99593 5.02373 9.82402 4.85182C9.65211 4.67991 9.41895 4.58334 9.17584 4.58334H9.16667Z" fill="#28C76F"/>
                                              </svg>
                                              {{ couponCodeInfoText }}
                                            </div>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                          </b-col>
                                        </b-row>
                                      </validation-provider></b-form-group>
                                  </b-col>
                                </b-row>
                                <div class="mobile-payment-details mb-1">
                                  <div class="mobile-payment-details-total">
                                    <div class="mobile-payment-details-item-title mb-05">
                                      {{ $t('Total amount') }}
                                    </div>
                                    <div
                                      class="mobile-payment-details-item-value"
                                      style="font-size: 15px"
                                    >
                                      {{ numberFormat(product.credits) }}
                                      {{ minCredits <= product.credits && couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
                                      {{ $t('Diamonds') }}
                                      | {{ currencySymbol(product.currency) }}{{ product.amount }}
                                    </div>
                                  </div>
                                </div>
                                <b-row>
                                  <b-col
                                    class="mt-2"
                                    xl="6"
                                    lg="6"
                                    md="12"
                                  >
                                    <b-button
                                      variant="primary"
                                      block
                                      class="btn-primary2"
                                      :disabled="loading || (isDynamicMarket && dynamicInitInFlight)"
                                      @click="buyWithCraftgate"
                                    >
                                      <div class="button-secure-icon">
                                        <b-img
                                          :src="iconSecureBuying"
                                          class=""
                                          height="26"
                                        />
                                      </div>
                                      {{ $t('Buy') }}
                                    </b-button>
                                  </b-col>
                                </b-row>
                                <div class="fs-12 color-black text-underline mt-1 mb-2 d-flex align-items-center gap-6">
                                  <svg
                                    width="16"
                                    height="20"
                                    viewBox="0 0 16 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M8 11C7.69555 10.9964 7.39732 11.0862 7.14544 11.2573C6.89357 11.4284 6.70015 11.6725 6.59121 11.9568C6.48228 12.2411 6.46306 12.552 6.53615 12.8476C6.60923 13.1431 6.77111 13.4092 7 13.61V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V13.61C9.22889 13.4092 9.39077 13.1431 9.46385 12.8476C9.53694 12.552 9.51772 12.2411 9.40879 11.9568C9.29985 11.6725 9.10643 11.4284 8.85456 11.2573C8.60268 11.0862 8.30445 10.9964 8 11ZM13 7V5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 0 8 0C6.67392 0 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5V7C2.20435 7 1.44129 7.31607 0.87868 7.87868C0.316071 8.44129 0 9.20435 0 10V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V10C16 9.20435 15.6839 8.44129 15.1213 7.87868C14.5587 7.31607 13.7956 7 13 7ZM5 5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2C8.79565 2 9.55871 2.31607 10.1213 2.87868C10.6839 3.44129 11 4.20435 11 5V7H5V5ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10C2 9.73478 2.10536 9.48043 2.29289 9.29289C2.48043 9.10536 2.73478 9 3 9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10V17Z" fill="black"/>
                                  </svg>
                                  {{ $t('Payments are secure and encrypted') }}
                                </div>
                              </b-col>
                            </b-row>
                          </b-form>
                        </validation-observer>
                      </div>
                      <div
                        v-else
                        class="buying-option-body"
                      >
                        <validation-observer
                          ref="form"
                          #default="{}"
                        >
                          <b-form
                            class="mt-2"
                            @submit.prevent
                          >
                            <b-row>
                              <b-col
                                xl="4"
                                lg="4"
                                md="5"
                                sm="12"
                              >
                                <div class="market-banner-mobile">
                                  <div class="market-banner-mobile-inner">
                                    <b-img
                                      :src="require('@/assets/images/icons/diamonds-3-new-3.svg')"
                                      width="74"
                                      height="72"
                                    />
                                    {{ $t('{count} You can keep chatting by buying diamonds!', {count: numberFormat(product.credits)}) }}
                                  </div>
                                </div>
                                <div class="market-banner-desktop">
                                  <b-img :src="require('@/assets/images/icons/diamonds-3-new-3.svg')" />
                                  <div class="market-banner-desktop-inner">
                                    <p>
                                      <b>
                                        {{ $t('Buy diamonds, enjoy the conversation and the fun') }}!
                                      </b>
                                    </p>
                                    <p>
                                      <span style="font-size: 18px; color: #EC065B;">
                                        {{ numberFormat(product.credits) }}
                                        {{ minCredits <= product.credits && couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
                                        {{ $t('Diamonds') }}
                                      </span>
                                    </p>
                                    <p>
                                      <span style="font-size: 14px;">
                                        {{ currencySymbol(product.currency) }}{{ product.amount }}
                                      </span>
                                    </p>
                                    <p>
                                      {{ $t('{count} You can keep chatting by buying diamonds!', {count: numberFormat(product.credits)}) }}
                                    </p>
                                  </div>
                                  <div class="market-banner-desktop-footer">
                                    <a
                                      :href="locale === 'tr' ? 'https://boholive.app/tr/uye-sozlesmesi' : 'https://boholive.app/terms-of-service'"
                                      target="_blank"
                                    >
                                      {{ $t('Terms') }}
                                    </a>
                                    <a
                                      :href="locale === 'tr' ? 'https://boholive.app/tr/gizlilik-ve-kullanim-kosullari' : 'https://boholive.app/membership-agreement'"
                                      target="_blank"
                                    >
                                      {{ $t('Privacy and Terms of Use') }}
                                    </a>
                                    <a
                                      v-if="locale === 'tr'"
                                      href="https://boholive.app/tr/kisisel-verilerin-korunmasi-politikasi"
                                      target="_blank"
                                    >
                                      {{ $t('KVKK') }}
                                    </a>
                                  </div>
                                </div>
                              </b-col>
                              <b-col
                                xl="6"
                                lg="6"
                                md="7"
                                sm="12"
                              >
                                <b-row>
                                  <b-col sm="12">
                                    <div class="card-type-title">
                                      {{ $t('Card type') }}
                                    </div>
                                    <div class="card-types">
                                      <div :class="{selected: cardType === 'visa'}">
                                        <b-img :src="require('@/assets/images/misc/visa.png')" />
                                      </div>
                                      <div :class="{selected: cardType === 'master'}">
                                        <b-img :src="require('@/assets/images/misc/master-card.png')" />
                                      </div>
                                      <div :class="{selected: cardType === 'other'}">
                                        <b-img :src="require('@/assets/images/misc/other-card.png')" />
                                        <span>
                                          {{ $t('Other') }}
                                        </span>
                                      </div>
                                    </div>
                                  </b-col>
                                  <b-col sm="12">
                                    <b-form-group
                                      label-for="cc-name"
                                      :label="$t('Name and Surname of the cardholder')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Name and Surname of the cardholder')"
                                        vid="firstName"
                                        rules="required"
                                      >
                                        <b-form-input
                                          id="cc-name"
                                          v-model="creditCard.name"
                                          autocomplete="cc-name"
                                          name="cc-name"
                                          :placeholder="$t('Name and Surname of the cardholder')"
                                          :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    v-if="false"
                                    sm="12"
                                  >
                                    <b-form-group
                                      label-for="email"
                                      :label="$t('Email')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Email')"
                                        vid="email"
                                        rules="required|email"
                                      >
                                        <b-form-input
                                          id="email"
                                          v-model="creditCard.email"
                                          name="email"
                                          :placeholder="$t('Email')"
                                          :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="12">
                                    <b-form-group
                                      label-for="cc-number"
                                      :label="$t('Credit card number')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Credit card number')"
                                        vid="number"
                                        rules="required|min:16"
                                      >
                                        <b-form-input
                                          id="cc-number"
                                          v-model="creditCard.number"
                                          v-mask="'#### #### #### ####'"
                                          masked="false"
                                          autocomplete="cc-number"
                                          name="cc-number"
                                          autocompletetype="cc-number"
                                          :placeholder="$t('Credit card number')"
                                          :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                          @input="detectCardType"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    v-if="false"
                                    sm="12"
                                  >
                                    <b-form-group
                                      label-for="phone"
                                      :label="$t('Phone number')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Phone number')"
                                        vid="phone"
                                        rules="required"
                                      >
                                        <vue-tel-input
                                          v-model="creditCard.phone"
                                          mode="auto"
                                          :input-options="{
                                            placeholder: $t('Phone number'),
                                            maxlength: 15,
                                            onlyNumbers: true
                                          }"
                                          valid-characters-only
                                          :style-classes="['phone-input']"
                                          @open="onDropdownOpen(true)"
                                          @close="onDropdownOpen(false)"
                                          @country-changed="countryChanged"
                                          @validate="phoneValidate"
                                          @input="validatePhoneInput"
                                        >
                                          <template v-slot:arrow-icon>
                                            <span class="font-small-3 mr-05">
                                              {{ country ? '+' + country.dialCode : '' }}
                                            </span>
                                            <font-awesome-icon
                                              v-if="open"
                                              icon="fa-solid fa-chevron-up"
                                            />
                                            <font-awesome-icon
                                              v-else
                                              icon="fa-solid fa-chevron-down"
                                            />
                                          </template>
                                        </vue-tel-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    sm="4"
                                    cols="6"
                                  >
                                    <b-form-group
                                      :label="$t('Date')"
                                      label-for="expiry-date"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Date')"
                                        vid="expiryDate"
                                        rules="required"
                                      >
                                        <b-input-group>
                                          <b-form-input
                                            id="expiry-date"
                                            v-model="formattedExpiryDate"
                                            autocomplete="cc-exp"
                                            :placeholder="$t('AA/YY')"
                                            name="cc-exp"
                                            style="width: 100%"
                                            @input="formatExpiryDate"
                                          />
                                          <b-input-group-append>
                                            <b-input-group-text style="border: none;">
                                              <svg
                                                width="25"
                                                height="28"
                                                viewBox="0 0 25 28"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                style="position: absolute; right: 16px; top: 40%; transform: translateY(-50%); z-index: 999;width: 20px; height: 22px;"
                                              >
                                                <path d="M12.5 17.485C12.1771 17.485 11.8958 17.3673 11.6562 17.1318C11.4167 16.8962 11.2969 16.6198 11.2969 16.3024C11.2969 15.9849 11.4167 15.709 11.6562 15.4745C11.8958 15.24 12.1771 15.1223 12.5 15.1212C12.8229 15.1202 13.1042 15.238 13.3437 15.4745C13.5833 15.711 13.7031 15.9875 13.7031 16.3039C13.7031 16.6203 13.5833 16.8962 13.3437 17.1318C13.1042 17.3673 12.8229 17.485 12.5 17.485ZM6.25 17.485C5.92708 17.485 5.64583 17.3673 5.40625 17.1318C5.16667 16.8962 5.04687 16.6198 5.04687 16.3024C5.04687 15.9849 5.16667 15.709 5.40625 15.4745C5.64583 15.24 5.92708 15.1223 6.25 15.1212C6.57292 15.1202 6.85417 15.238 7.09375 15.4745C7.33333 15.711 7.45312 15.9875 7.45312 16.3039C7.45312 16.6203 7.33333 16.8962 7.09375 17.1318C6.85417 17.3673 6.57292 17.485 6.25 17.485ZM18.75 17.485C18.4271 17.485 18.1458 17.3673 17.9062 17.1318C17.6667 16.8962 17.5469 16.6198 17.5469 16.3024C17.5469 15.9849 17.6667 15.709 17.9062 15.4745C18.1458 15.24 18.4271 15.1223 18.75 15.1212C19.0729 15.1202 19.3542 15.238 19.5937 15.4745C19.8333 15.711 19.9531 15.9875 19.9531 16.3039C19.9531 16.6203 19.8333 16.8962 19.5937 17.1318C19.3542 17.3673 19.0729 17.485 18.75 17.485ZM12.5 23.3922C12.1771 23.3922 11.8958 23.2745 11.6562 23.0389C11.4167 22.8034 11.2969 22.527 11.2969 22.2095C11.2969 21.8921 11.4167 21.6162 11.6562 21.3817C11.8958 21.1472 12.1771 21.0294 12.5 21.0284C12.8229 21.0274 13.1042 21.1451 13.3437 21.3817C13.5833 21.6182 13.7031 21.8947 13.7031 22.2111C13.7031 22.5275 13.5833 22.8039 13.3437 23.0405C13.1042 23.277 12.8229 23.3943 12.5 23.3922ZM6.25 23.3922C5.92708 23.3922 5.64583 23.2745 5.40625 23.0389C5.16667 22.8034 5.04687 22.527 5.04687 22.2095C5.04687 21.8921 5.16667 21.6162 5.40625 21.3817C5.64583 21.1472 5.92708 21.0294 6.25 21.0284C6.57292 21.0274 6.85417 21.1451 7.09375 21.3817C7.33333 21.6182 7.45312 21.8947 7.45312 22.2111C7.45312 22.5275 7.33333 22.8039 7.09375 23.0405C6.85417 23.277 6.57292 23.3943 6.25 23.3922ZM18.75 23.3922C18.4271 23.3922 18.1458 23.2745 17.9062 23.0389C17.6667 22.8034 17.5469 22.527 17.5469 22.2095C17.5469 21.8921 17.6667 21.6162 17.9062 21.3817C18.1458 21.1472 18.4271 21.0294 18.75 21.0284C19.0729 21.0274 19.3542 21.1451 19.5937 21.3817C19.8333 21.6182 19.9531 21.8947 19.9531 22.2111C19.9531 22.5275 19.8333 22.8039 19.5937 23.0405C19.3542 23.277 19.0729 23.3943 18.75 23.3922ZM2.525 28C1.80521 28 1.20469 27.7635 0.723437 27.2904C0.242187 26.8173 0.00104167 26.227 0 25.5195V5.90565C0 5.19912 0.241146 4.60932 0.723437 4.13626C1.20573 3.66319 1.80625 3.42615 2.525 3.42512H5.28906V0H6.97187V3.42512H18.15V0H19.7125V3.42512H22.4766C23.1953 3.42512 23.7958 3.66217 24.2781 4.13626C24.7604 4.61035 25.001 5.20066 25 5.90719V25.5195C25 26.226 24.7594 26.8163 24.2781 27.2904C23.7969 27.7645 23.1958 28.001 22.475 28H2.525ZM2.525 26.4641H22.4766C22.7161 26.4641 22.9365 26.3658 23.1375 26.1692C23.3385 25.9726 23.4385 25.7555 23.4375 25.5179V12.0509H1.5625V25.5195C1.5625 25.755 1.6625 25.9715 1.8625 26.1692C2.0625 26.3668 2.28281 26.4651 2.52344 26.4641" fill="#AB32F1"/>
                                              </svg>
                                            </b-input-group-text>
                                          </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    v-if="false"
                                    sm="4"
                                  >
                                    <b-form-group
                                      :label="$t('Year')"
                                      label-for="cc-exp-year"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Year')"
                                        vid="year"
                                        rules="required"
                                      >
                                        <v-select
                                          id="cc-exp-year"
                                          v-model="creditCard.year"
                                          :clearable="false"
                                          :options="years"
                                          autocomplete="cc-exp-year"
                                          :placeholder="$t('Year')"
                                          name="cc-exp-year"
                                          :selectable="option => ! option.includes($t('Year'))"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                  <b-col
                                    sm="4"
                                    cols="6"
                                  >
                                    <b-form-group
                                      label-for="cvv"
                                      label="CVV"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        name="CVV"
                                        vid="cvv"
                                        rules="required"
                                      >
                                        <b-input-group>
                                          <b-form-input
                                            id="cvv"
                                            v-model="creditCard.cvv"
                                            v-mask="['###']"
                                            :type="cvvPassword ? 'password' : 'text'"
                                            masked="false"
                                            autocomplete="cc-csc"
                                            name="cc-csc"
                                            autocompletetype="cc-csc"
                                            placeholder="CVV"
                                            :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                          />
                                          <b-input-group-append>
                                            <svg
                                              width="24"
                                              height="16"
                                              viewBox="0 0 24 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              style="cursor: pointer; position: absolute; right: 16px; top: 50%; transform: translateY(-50%); z-index: 999;"
                                              @click="cvvPassword = !cvvPassword"
                                            >
                                              <path d="M23.1588 7.41844C23.1241 7.3425 22.3029 5.51906 20.4888 3.705C18.0616 1.28156 15.0026 0 11.6276 0C8.25257 0 5.1935 1.28156 2.76913 3.705C0.955065 5.51906 0.133815 7.3425 0.0963153 7.41844C0.0328026 7.56243 0 7.71809 0 7.87547C0 8.03285 0.0328026 8.1885 0.0963153 8.3325C0.131003 8.40938 0.952253 10.2319 2.76725 12.0459C5.1935 14.4694 8.25257 15.75 11.6276 15.75C15.0026 15.75 18.0616 14.4694 20.4851 12.0459C22.3001 10.2319 23.1213 8.40938 23.156 8.3325C23.22 8.1887 23.2532 8.03315 23.2537 7.87577C23.2542 7.71838 23.2219 7.56263 23.1588 7.41844ZM18.8407 10.5122C16.8279 12.4941 14.4016 13.5 11.6276 13.5C8.8535 13.5 6.42725 12.4941 4.41725 10.5112C3.62633 9.72865 2.94598 8.84171 2.39507 7.875C2.94614 6.90868 3.62647 6.02207 4.41725 5.23969C6.42819 3.25594 8.8535 2.25 11.6276 2.25C14.4016 2.25 16.8269 3.25594 18.8379 5.23969C19.6287 6.022 20.3091 6.90862 20.8601 7.875C20.3091 8.84165 19.6287 9.72858 18.8379 10.5112L18.8407 10.5122ZM11.6276 3.75C10.8117 3.75 10.0142 3.99193 9.33584 4.44519C8.65749 4.89845 8.12877 5.54269 7.81656 6.29643C7.50435 7.05018 7.42266 7.87958 7.58183 8.67975C7.74099 9.47992 8.13386 10.2149 8.71075 10.7918C9.28764 11.3687 10.0226 11.7616 10.8228 11.9207C11.623 12.0799 12.4524 11.9982 13.2061 11.686C13.9599 11.3738 14.6041 10.8451 15.0574 10.1667C15.5106 9.48837 15.7526 8.69085 15.7526 7.875C15.7513 6.78136 15.3163 5.73287 14.543 4.95955C13.7697 4.18624 12.7212 3.75124 11.6276 3.75ZM11.6276 9.75C11.2567 9.75 10.8942 9.64003 10.5859 9.43401C10.2775 9.22798 10.0372 8.93514 9.89529 8.59253C9.75338 8.24992 9.71625 7.87292 9.78859 7.50921C9.86094 7.14549 10.0395 6.8114 10.3017 6.54917C10.564 6.28695 10.8981 6.10837 11.2618 6.03603C11.6255 5.96368 12.0025 6.00081 12.3451 6.14273C12.6877 6.28464 12.9805 6.52496 13.1866 6.83331C13.3926 7.14165 13.5026 7.50416 13.5026 7.875C13.5026 8.37228 13.305 8.84919 12.9534 9.20082C12.6018 9.55246 12.1248 9.75 11.6276 9.75Z" fill="#AB32F1"/>
                                            </svg>
                                          </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col
                                    v-if="product && product.credits >= 0 && !isDynamicMarket"
                                    sm="12"
                                  >
                                    <b-form-group
                                      label-for="coupon-code"
                                      :label="$t('Coupon Code')"
                                    >
                                      <validation-provider
                                        #default="{ errors }"
                                        :name="$t('Coupon Code')"
                                        vid="number"
                                        rules="min:4"
                                      >
                                        <b-row>
                                          <b-col sm="12">
                                            <b-input-group>
                                              <b-form-input
                                                v-model="couponCode"
                                                style="border-bottom-right-radius: 0 !important; border-top-right-radius: 0 !important;"
                                                name="couponCode"
                                                :disabled="couponCodeSucceed"
                                                :placeholder="$t('Enter Your Coupon')"
                                              />
                                              <b-input-group-append>
                                                <b-button
                                                  size="sm"
                                                  variant="success"
                                                  :disabled="couponCodeSucceed || loading || couponCode.length < 4"
                                                  @click="applyCouponCode"
                                                >
                                                  {{ $t('Use Coupon') }}
                                                </b-button>
                                              </b-input-group-append>
                                            </b-input-group>
                                            <div
                                              class="mt-05 fs-11 color-black fw-400"
                                              :class="couponCodeInfoColor"
                                            >
                                              <svg
                                                width="19"
                                                height="19"
                                                viewBox="0 0 19 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M9.16667 1.83333C7.22175 1.83333 5.35649 2.60595 3.98122 3.98122C2.60595 5.35649 1.83333 7.22175 1.83333 9.16667C1.83333 11.1116 2.60595 12.9769 3.98122 14.3521C5.35649 15.7274 7.22175 16.5 9.16667 16.5C11.1116 16.5 12.9769 15.7274 14.3521 14.3521C15.7274 12.9769 16.5 11.1116 16.5 9.16667C16.5 7.22175 15.7274 5.35649 14.3521 3.98122C12.9769 2.60595 11.1116 1.83333 9.16667 1.83333ZM0 9.16667C0 4.10392 4.10392 0 9.16667 0C14.2294 0 18.3333 4.10392 18.3333 9.16667C18.3333 14.2294 14.2294 18.3333 9.16667 18.3333C4.10392 18.3333 0 14.2294 0 9.16667ZM9.16667 13.75C9.40979 13.75 9.64294 13.6534 9.81485 13.4815C9.98676 13.3096 10.0833 13.0765 10.0833 12.8333V9.16667C10.0833 8.92356 9.98676 8.6904 9.81485 8.51849C9.64294 8.34658 9.40979 8.25 9.16667 8.25C8.92356 8.25 8.6904 8.34658 8.51849 8.51849C8.34658 8.6904 8.25 8.92356 8.25 9.16667V12.8333C8.25 13.0765 8.34658 13.3096 8.51849 13.4815C8.6904 13.6534 8.92356 13.75 9.16667 13.75ZM9.16667 4.58334C8.92356 4.58334 8.6904 4.67991 8.51849 4.85182C8.34658 5.02373 8.25 5.25689 8.25 5.5C8.25 5.74312 8.34658 5.97628 8.51849 6.14818C8.6904 6.32009 8.92356 6.41667 9.16667 6.41667H9.17584C9.41895 6.41667 9.65211 6.32009 9.82402 6.14818C9.99593 5.97628 10.0925 5.74312 10.0925 5.5C10.0925 5.25689 9.99593 5.02373 9.82402 4.85182C9.65211 4.67991 9.41895 4.58334 9.17584 4.58334H9.16667Z" fill="#28C76F"/>
                                              </svg>
                                              {{ couponCodeInfoText }}
                                            </div>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                          </b-col>
                                        </b-row>
                                      </validation-provider></b-form-group>
                                  </b-col>
                                </b-row>
                                <div class="mobile-payment-details mb-1">
                                  <div class="mobile-payment-details-total">
                                    <div class="mobile-payment-details-item-title mb-05">
                                      {{ $t('Total amount') }}
                                    </div>
                                    <div
                                      class="mobile-payment-details-item-value"
                                      style="font-size: 15px"
                                    >
                                      {{ numberFormat(product.credits) }}
                                      {{ couponCodeBonusRatio && product.credits >= 0 ? `+ ${numberFormat(product.credits * couponCodeBonusRatio)}` : null }}
                                      {{ $t('Diamonds') }}
                                      | {{ currencySymbol(product.currency) }}{{ product.amount }}
                                    </div>
                                  </div>
                                </div>
                                <b-row>
                                  <b-col
                                    class="mt-2"
                                    xl="6"
                                    lg="6"
                                    md="12"
                                  >
                                    <b-button
                                      variant="primary"
                                      block
                                      class="btn-primary2"
                                      :disabled="loading || (isDynamicMarket && dynamicInitInFlight)"
                                      @click="buyWithCreditCard"
                                    >
                                      <div class="button-secure-icon">
                                        <b-img
                                          :src="iconSecureBuying"
                                          class=""
                                          height="26"
                                        />
                                      </div>
                                      {{ $t('Buy') }}
                                    </b-button>
                                  </b-col>
                                </b-row>
                                <div class="fs-12 color-black text-underline mt-1 mb-2 d-flex align-items-center gap-6">
                                  <svg
                                    width="16"
                                    height="20"
                                    viewBox="0 0 16 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M8 11C7.69555 10.9964 7.39732 11.0862 7.14544 11.2573C6.89357 11.4284 6.70015 11.6725 6.59121 11.9568C6.48228 12.2411 6.46306 12.552 6.53615 12.8476C6.60923 13.1431 6.77111 13.4092 7 13.61V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V13.61C9.22889 13.4092 9.39077 13.1431 9.46385 12.8476C9.53694 12.552 9.51772 12.2411 9.40879 11.9568C9.29985 11.6725 9.10643 11.4284 8.85456 11.2573C8.60268 11.0862 8.30445 10.9964 8 11ZM13 7V5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 0 8 0C6.67392 0 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5V7C2.20435 7 1.44129 7.31607 0.87868 7.87868C0.316071 8.44129 0 9.20435 0 10V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V10C16 9.20435 15.6839 8.44129 15.1213 7.87868C14.5587 7.31607 13.7956 7 13 7ZM5 5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2C8.79565 2 9.55871 2.31607 10.1213 2.87868C10.6839 3.44129 11 4.20435 11 5V7H5V5ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10C2 9.73478 2.10536 9.48043 2.29289 9.29289C2.48043 9.10536 2.73478 9 3 9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10V17Z" fill="black"/>
                                  </svg>
                                  {{ $t('Payments are secure and encrypted') }}
                                </div>
                              </b-col>
                            </b-row>
                          </b-form>
                        </validation-observer>
                      </div>
                    </b-collapse>
                  </div>
                  <div
                    v-if="!isDynamicMarket && mobileProduct && mobileProduct.currency === 'TRY' && product.currency === mobileProduct.currency"
                    id="option-mobile"
                    class="buying-option"
                  >
                    <div
                      v-b-toggle.accordion-2
                      class="buying-option-header"
                      role="tab"
                      @click="scrollTo('option-mobile')"
                    >
                      <div>
                        {{ $t('Mobile payment') }}
                      </div>
                      <div class="fs-14 color-gray fw-300">
                        {{ $t('Make secure payments over your phone line with the mobile payment method') }}
                      </div>
                    </div>
                    <b-collapse
                      id="accordion-2"
                      accordion="my-accordion"
                      role="tabpanel"
                      :visible="false"
                    >
                      <div class="buying-option-body">
                        <div class="fs-14 fw-500 font-inter color-black mt-2">
                          {{ $t('Only available in Turkey') }}
                        </div>
                        <validation-observer
                          ref="mobileForm"
                        >
                          <b-form
                            class="mt-2"
                            @submit.prevent
                          >
                            <b-row v-show="false">
                              <b-col
                                md="6"
                                sm="12"
                              >
                                <b-form-group
                                  label-for="firstname"
                                  :label="$t('Firstname')"
                                >
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Firstname')"
                                    vid="firstName"
                                  >
                                    <b-form-input
                                      id="firstname"
                                      v-model="mobilePayment.firstname"
                                      name="firstname"
                                      disabled
                                      :placeholder="$t('Firstname')"
                                      :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col
                                md="6"
                                sm="12"
                              >
                                <b-form-group
                                  label-for="lastname"
                                  :label="$t('Lastname')"
                                >
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Lastname')"
                                    vid="lastname"
                                  >
                                    <b-form-input
                                      id="lastname"
                                      v-model="mobilePayment.lastname"
                                      name="lastname"
                                      disabled
                                      :placeholder="$t('Lastname')"
                                      :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row v-show="false">
                              <b-col
                                md="6"
                                sm="12"
                              >
                                <b-form-group
                                  label-for="email"
                                  :label="$t('Email')"
                                >
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Email')"
                                    vid="email"
                                  >
                                    <b-form-input
                                      id="email"
                                      v-model="mobilePayment.email"
                                      name="email"
                                      disabled
                                      :placeholder="$t('Email')"
                                      :state="Array.isArray(errors) && errors.length > 0 ? false : null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col
                                md="6"
                                sm="12"
                              >
                                <b-form-group
                                  label-for="phone"
                                  :label="$t('Phone number')"
                                >
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Phone number')"
                                    vid="phone"
                                  >
                                    <vue-tel-input
                                      v-model="mobilePayment.phone"
                                      mode="auto"
                                      disabled
                                      :input-options="{placeholder: $t('Phone number')}"
                                      valid-characters-only
                                      :style-classes="['phone-input']"
                                      @open="onDropdownOpen(true)"
                                      @close="onDropdownOpen(false)"
                                      @country-changed="countryChanged"
                                      @validate="phoneValidate"
                                    >
                                      <template v-slot:arrow-icon>
                                        <span class="font-small-3 mr-05">
                                          {{ country ? '+' + country.dialCode : '' }}
                                        </span>
                                        <font-awesome-icon
                                          v-if="open"
                                          icon="fa-solid fa-chevron-up"
                                        />
                                        <font-awesome-icon
                                          v-else
                                          icon="fa-solid fa-chevron-down"
                                        />
                                      </template>
                                    </vue-tel-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-form>
                        </validation-observer>
                        <b-row>
                          <b-col
                            md="6"
                            sm="12"
                          >
                            <div
                              v-if="mobileProduct"
                              class="mobile-payment-details"
                            >
                              <div class="mobile-payment-details-item">
                                <div>
                                  {{ $t('Package amount') }}
                                </div>
                                <div
                                  class="mobile-payment-details-item-value mb-1"
                                  style="font-size: 15px"
                                >
                                  {{ numberFormat(mobileProduct.credits) }} {{ $t('Diamonds') }} |
                                  {{ currencySymbol(product.currency) }}{{ parseFloat(mobileProduct.amount - product.amount) > 0 ? parseFloat(mobileProduct.amount - (mobileProduct.amount - product.amount)).toFixed(2) : parseFloat(mobileProduct.amount).toFixed(2) }}
                                </div>
                                <div class="mobile-payment-details-item-title mb-05">
                                  {{ $t('Mobile payment service provider fee') }}
                                </div>
                                <div
                                  class="mb-05"
                                  style="font-size: 15px"
                                >
                                  {{ currencySymbol(product.currency) }}{{ parseFloat(mobileProduct.amount - product.amount) > 0 ? parseFloat(mobileProduct.amount - product.amount).toFixed(2) : '0.00' }}
                                </div>
                              </div>
                              <hr>
                              <div class="mobile-payment-details-total">
                                <div class="mobile-payment-details-item-title">
                                  {{ $t('Total amount') }}
                                </div>
                                <div
                                  class="mobile-payment-details-item-value"
                                  style="font-size: 15px"
                                >
                                  {{ numberFormat(mobileProduct.credits) }} {{ $t('Diamonds') }} |
                                  ₺{{ parseFloat(mobileProduct.amount).toFixed(2) }}
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            class="mt-2 mb-1 pl-0"
                            xl="6"
                            lg="6"
                            md="12"
                          >
                            <b-button
                              variant="primary"
                              block
                              class="btn-primary2"
                              style="position: relative;"
                              @click="buyMobilePurchase"
                            >
                              <div class="button-secure-icon">
                                <b-img
                                  :src="iconSecureBuying"
                                  class=""
                                  height="26"
                                />
                              </div>
                              <div class="d-flex flex-column">
                                <span>
                                  {{ $t('Buy') }}
                                </span>
                              </div>
                            </b-button>
                            <div class="fs-12 text-center color-black text-underline mt-1">
                              {{ $t('You will continue the payment on PayByMe') }}
                            </div>
                            <div
                              class="fs-12 text-center color-black text-underline mt-1 d-flex align-items-center justify-content-center gap-6">
                              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 11C7.69555 10.9964 7.39732 11.0862 7.14544 11.2573C6.89357 11.4284 6.70015 11.6725 6.59121 11.9568C6.48228 12.2411 6.46306 12.552 6.53615 12.8476C6.60923 13.1431 6.77111 13.4092 7 13.61V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V13.61C9.22889 13.4092 9.39077 13.1431 9.46385 12.8476C9.53694 12.552 9.51772 12.2411 9.40879 11.9568C9.29985 11.6725 9.10643 11.4284 8.85456 11.2573C8.60268 11.0862 8.30445 10.9964 8 11ZM13 7V5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 0 8 0C6.67392 0 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5V7C2.20435 7 1.44129 7.31607 0.87868 7.87868C0.316071 8.44129 0 9.20435 0 10V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V10C16 9.20435 15.6839 8.44129 15.1213 7.87868C14.5587 7.31607 13.7956 7 13 7ZM5 5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2C8.79565 2 9.55871 2.31607 10.1213 2.87868C10.6839 3.44129 11 4.20435 11 5V7H5V5ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10C2 9.73478 2.10536 9.48043 2.29289 9.29289C2.48043 9.10536 2.73478 9 3 9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10V17Z" fill="black"/>
                              </svg>
                              {{ $t('Payments are secure and encrypted') }}
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            class="d-flex flex-column align-items-center justify-content-center mb-2"
                            xl="6"
                            lg="6"
                            md="12"
                          >
                            <p class="fs-12 color-black mt-2">
                              {{ $t('How do I open my line for mobile payment?') }}
                            </p>
                            <p class="fs-12 color-gray-2 fw-400 mt--1">
                              <a
                                href="https://www.turkcell.com.tr/yardim/servisler-ve-internet/servisler/telefonumu-mobil-odeme-kullanimina-nasil-acabilirim"
                                class="text-decoration-underline mr-1"
                                target="_blank"
                              >
                                Turkcell
                              </a>
                              <a
                                href="https://www.vodafone.com.tr/Servisler/cep-cuzdan-mobil-odeme.php"
                                class="text-decoration-underline mr-1"
                                target="_blank"
                              >
                                Vodafone
                              </a>
                              <a
                                v-if="false"
                                href="https://bireysel.turktelekom.com.tr/mobil/web/servisler/sayfalar/turk-telekom-mobil-odeme.aspx"
                                class="text-decoration-underline"
                                target="_blank"
                              >
                                Turk Telekom
                              </a>
                            </p>
                          </b-col>
                        </b-row>
                      </div>
                    </b-collapse>
                  </div>
                  <div
                    v-if="!isDynamicMarket && product.currency === 'TRY' && campaignType !== 'ONE_TIME_OFFER'"
                    id="option-transfer"
                    class="buying-option"
                  >
                    <div
                      v-b-toggle.accordion-3
                      class="buying-option-header"
                      role="tab"
                      @click="scrollTo('option-transfer')"
                    >
                      <div>
                        {{ $t('Payment by Wire Transfer / EFT / FAST') }}
                      </div>
                      <div class="fs-14 color-gray fw-300">
                        {{ $t('Easily pay into our bank accounts') }}
                      </div>
                    </div>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                      :visible="false"
                    >
                      <div class="buying-option-body">
                        <h5 class="color-black fs-14 mt-2">
                          {{ $t('How to Pay Boho by Wire Transfer?') }}
                        </h5>
                        <p class="color-black fs-12 fw-400">
                          {{ $t('From your personal bank account or if you do not have a bank account, you can send the amount up to the minute you want to buy, via wire transfer or eft, from any ATM to one of the bank accounts of Boho below.') }}
                          <span
                            class="cursor-pointer text-decoration-underline fw-600"
                            @click="showTransferPaymentDetail = !showTransferPaymentDetail"
                          >
                            {{ $t('Click for more detailed information') }}.
                          </span>
                        </p>
                        <div
                          v-if="showTransferPaymentDetail"
                          class="mb-2 mt-2"
                        >
                          <div class="d-flex justify-content-between mb-1">
                            <div class="d-flex flex-column align-items-center">
                              <b-img :src="bankIcon1" />
                              <div
                                style="width: 180px"
                                class="text-center fw-600"
                              >
                                {{ $t('Internet and Telephone Banking') }}
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              {{ $t('The name of the account owner appears as the sender, since the transfers you make over the Internet and telephone banking are made from your account. Send us your Boho account information with your receipt, and it will be uploaded to the diamond\'s account.') }}
                            </div>
                          </div>
                          <div class="d-flex justify-content-between mb-1">
                            <div class="d-flex flex-column align-items-center">
                              <b-img :src="bankIcon2" />
                              <div
                                style="width: 180px"
                                class="text-center fw-600"
                              >
                                {{ $t('From the bank branch') }}
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              {{ $t('Even if you do not have a bank account of your own, you can make money transfers from bank branches. Indicate the amount you want to deposit by forwarding the Boho bank account information to the bank officer. Then, send us the receipt and Boho account information given to you, and the diamond will be loaded into your account.') }}
                            </div>
                          </div>
                          <div class="d-flex justify-content-between mb-1">
                            <div class="d-flex flex-column align-items-center">
                              <b-img :src="bankIcon3" />
                              <div
                                style="width: 180px"
                                class="text-center fw-600"
                              >
                                {{ $t('ATM') }}
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              {{ $t('You do not need to have a card to make money transfers from ATMs. At the end of the transaction, you can send the copy of the receipt you will receive from the ATM or the transaction number and Boho account information on the receipt, and you can have the diamond loaded into your account.') }}
                            </div>
                          </div>
                        </div>
                        <b-alert
                          show
                          variant="warning"
                          class="p-2"
                        >
                          {{ $t('After making the transfer, you need to send the receipt, bank name, username and phone number in Boho to the support@boholive.app e-mail address.') }}
                        </b-alert>
                        <h5 class="bank-account-heading">
                          {{ $t('Boho Account Information') }}
                        </h5>
                        <div class="mt-1">
                          <b-row>
                            <!-- Yapı Kredi - Yorum satırına alındı
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                            >
                              <b-card
                                tag="article"
                                class="mb-2"
                              >
                                <div class="text-center mb-1">
                                  <a
                                    href="https://www.yapikredi.com.tr/"
                                    target="_blank"
                                  >
                                    <b-img
                                      :src="bankYapiKredi"
                                      height="54"
                                    />
                                  </a>
                                </div>
                                <b-card-text>
                                  <b>{{ $t('Bank') }} : </b> Yapı Kredi Bankası <br>
                                  <b>{{ $t('IBAN') }} : </b> TR77 0006 7010 0000 0045 0168 00 <br>
                                  <b>{{ $t('RECEIVER') }} : </b> Arasana
                                </b-card-text>
                              </b-card>
                            </b-col>
                            -->
                            <!-- Garanti - Yorum satırına alındı
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                            >
                              <b-card
                                tag="article"
                                class="mb-2"
                              >
                                <div class="text-center mb-1">
                                  <a
                                    href="https://www.garantibbva.com.tr/"
                                    target="_blank"
                                  >
                                    <b-img
                                      :src="bankGaranti"
                                      height="54"
                                    />
                                  </a>
                                </div>
                                <b-card-text>
                                  <b>{{ $t('Bank') }} : </b> Garanti Bankası <br>
                                  <b>{{ $t('IBAN') }} : </b> TR14 0006 2001 4700 0006 2991 86 <br>
                                  <b>{{ $t('RECEIVER') }} : </b> Arasana
                                </b-card-text>
                              </b-card>
                            </b-col>
                            -->
                            <!-- İş Bankası - Yorum satırına alındı
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                            >
                              <b-card
                                tag="article"
                                class="mb-2"
                              >
                                <div class="text-center mb-1">
                                  <a
                                    href="https://www.isbank.com.tr/"
                                    target="_blank"
                                  >
                                    <b-img
                                      :src="bankIsbank"
                                      height="54"
                                    />
                                  </a>
                                </div>
                                <b-card-text>
                                  <b>{{ $t('Bank') }} : </b> İş Bankası <br>
                                  <b>{{ $t('IBAN') }} : </b> TR60 0006 4000 0011 0520 9890 33 <br>
                                  <b>{{ $t('RECEIVER') }} : </b> Arasana
                                </b-card-text>
                              </b-card>
                            </b-col>
                            -->
                            <!-- Akbank - Yorum satırına alındı
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                            >
                              <b-card
                                tag="article"
                                class="mb-2"
                              >
                                <div class="text-center mb-1">
                                  <a
                                    href="https://www.akbank.com/tr-tr/sayfalar/default.aspx"
                                    target="_blank"
                                  >
                                    <b-img
                                      :src="bankAkbank"
                                      height="54"
                                    />
                                  </a>
                                </div>
                                <b-card-text>
                                  <b>{{ $t('Bank') }} : </b> Akbank <br>
                                  <b>{{ $t('IBAN') }} : </b> TR21 0004 6010 2488 8000 1015 31 <br>
                                  <b>{{ $t('RECEIVER') }} : </b> Arasana
                                </b-card-text>
                              </b-card>
                            </b-col>
                            -->
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                            >
                              <b-card
                                tag="article"
                                class="mb-2 bank-account-card"
                              >
                                <div class="text-center mb-1">
                                  <a
                                    href="https://www.ziraatbank.com.tr/tr"
                                    target="_blank"
                                  >
                                    <b-img
                                      :src="bankZiraat"
                                      height="42"
                                    />
                                  </a>
                                </div>
                                <b-card-text>
                                  <b>{{ $t('Bank') }} : </b> Ziraat Bankası <br>
                                  <b>{{ $t('IBAN') }} : </b> TR 4100 0100 2507 8053 6226 5004 <br>
                                  <b>{{ $t('RECEIVER') }} : </b> Arasana
                                </b-card-text>
                              </b-card>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-overlay>

      <form
        v-if="paymentData"
        ref="posnetForm"
        method="post"
        :action="posnetUrl"
      >
        <input
          id="posnetData"
          name="posnetData"
          type="hidden"
          :value="paymentData.posnetData"
        >
        <input
          id="posnetData2"
          name="posnetData2"
          type="hidden"
          :value="paymentData.posnetData2"
        >
        <input
          id="mid"
          name="mid"
          type="hidden"
          :value="paymentData.mid"
        >
        <input
          id="posnetID"
          name="posnetID"
          type="hidden"
          :value="paymentData.posnetId"
        >
        <input
          id="sign"
          name="digest"
          type="hidden"
          :value="paymentData.digest"
        >
        <input
          id="merchantReturnURL"
          name="merchantReturnURL"
          type="hidden"
          :value="callbackUrl"
        >
        <input
          id="lang"
          name="lang"
          type="hidden"
          value="tr"
        >
        <input
          id="url"
          name="url"
          type="hidden"
          :value="currentUrl"
        >
      </form>
    </div>
    <div v-else>
      <div v-if="loading">
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
        <b-skeleton animation="wave" />
      </div>
      <b-card
        v-else
        tag="article"
      >
        <b-card-title>
          404
        </b-card-title>
        <b-card-text>
          {{ $t('Product not found') }}
        </b-card-text>
      </b-card>
    </div>

    <b-modal
      v-model="modalMinCreditsForProduct"
      centered
      hide-header-close
      hide-footer
      hide-header
      size="md"
    >
      <b-row class="password-information text-center mb-2">
        <b-col md="12">
          <div class="d-flex justify-content-center align-items-center flex-column pt-2 py-2">
            <h5 class="fs-20 fw-500 text-center color-black">
              {{ $t('minCreditsProductForCouponCode', {minCredits: numberFormatter(minCredits)}) }}
            </h5>
          </div>
        </b-col>
        <b-col sm="12">
          <div class="d-flex flex-column gap-6">
            <router-link :to="{ name: 'market' }">
              <b-button
                size="sm"
                class="btn-primary2"
                variant="success"
              >
                {{ $t('Go market') }}
              </b-button>
            </router-link>
            <a class="cursor-pointer text-underline" @click="modalMinCreditsForProduct = false">
              {{ $t('Bu ürünle devam') }}
            </a>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BAlert, BButton, BCard, BCardTitle, BCardText, BCol, BCollapse, BForm, BFormGroup, BFormInput, BImg, BInputGroup,
  BInputGroupAppend, BInputGroupText, BOverlay, BRow, BSkeleton, BModal,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import {
  throwDefaultError, throwPaymentError, convertTrChars, numberFormat, numberFormatter,
} from '@/helpers/helpers'
import vSelect from 'vue-select'
// import * as Card from 'card'
import { mask } from 'vue-the-mask'
import {setPaymentCraftgate} from "@/store/payment/actions";
// eslint-disable-next-line import/no-cycle
import dynamicMarket, { unwrapMarket } from '@/services/DynamicMarketService'
import dynamicMessages from './dynamicMarketMessages'
import { MARKET_PRODUCT_ID, validOfferId, checkoutReady, productFromOffer } from './dynamicMarketCheckout'

const posnetUrl = process.env.VUE_APP_POSNET_URL
const appUrl = process.env.VUE_APP_URL

const bankAkbank = require('@/assets/images/banks/akbank.png')
const bankGaranti = require('@/assets/images/banks/garanti.png')
const bankIsbank = require('@/assets/images/banks/isbank.png')
const bankYapiKredi = require('@/assets/images/banks/yapikredi.jpeg')
const bankZiraat = require('@/assets/images/banks/ziraat.jpg')
const bankIcon1 = require('@/assets/images/banks/icon_1.png')
const bankIcon2 = require('@/assets/images/banks/icon_2.png')
const bankIcon3 = require('@/assets/images/banks/icon_3.png')
const iconDiamonds1 = require('@/assets/images/icons/diamonds-1.svg')
const iconSecureBuying = require('@/assets/images/icons/secure-buying.svg')

export default {
  directives: { mask },
  components: {
    BModal,
    BAlert,
    BButton,
    BCard,
    BCardTitle,
    BCardText,
    BCol,
    BCollapse,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
    BOverlay,
    BRow,
    BSkeleton,

    ValidationProvider,
    ValidationObserver,

    vSelect,
  },
  data() {
    return {
      bankAkbank,
      bankGaranti,
      bankIcon1,
      bankIcon2,
      bankIcon3,
      bankIsbank,
      bankYapiKredi,
      bankZiraat,
      callbackUrl: `${appUrl}/payment/credit-card/finalize`,
      campaignId: null,
      campaignType: null,
      cardType: 'other',
      creditCard: {
        name: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        number: '',
        month: '',
        year: '',
        cvv: '',
      },
      country: null,
      couponCode: '',
      couponCodeBonusRatio: null,
      couponCodeInfoColor: 'color-gray',
      couponCodeInfoText: this.$t('Coupon is single use, not reusable'),
      couponCodeSucceed: false,
      cvvPassword: true,
      formattedExpiryDate: '',
      iconDiamonds1,
      iconSecureBuying,
      loading: false,
      minCredits: null,
      mobilePayment: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
      },
      mobileProduct: null,
      modalMinCreditsForProduct: false,
      months: [
        'Ay',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
      open: false,
      paybymeRedirectUrl: 'https://order.payby.me/webpayment/Pay.aspx',
      paymentData: null,
      paymentGateway: process.env.VUE_APP_PAYMENT_TYPE || 'posnet', // posnet || craftgate
      posnetUrl,
      product: null,
      productId: null,
      purchaseSource: 'market',
      showTransferPaymentDetail: false,
      valid: false,
      dynamicOfferId: null,
      dynamicOffer: null,
      dynamicError: '',
      dynamicInitInFlight: false,
    }
  },
  computed: {
    isDynamicMarket() { return this.productId === MARKET_PRODUCT_ID },
    dynamicCopy() { return dynamicMessages[this.$i18n.locale] || dynamicMessages.en },
    currentUrl() {
      if (this.isDynamicMarket) return new URL(this.$router.resolve({ name: 'buy', params: { productId: MARKET_PRODUCT_ID }, query: { marketOfferId: this.dynamicOfferId } }).href, appUrl).href
      const route = this.$router.resolve({ name: 'buy', params: { id: this.productId } })

      return appUrl + route?.href
    },
    paymentHtml() {
      if (!this.paymentData) return ''

      return `
      <div>
        <form v-if="paymentData" ref="posnetForm" id="posnetForm" method="post" action="${this.posnetUrl}">
          <input name="posnetData" type="hidden" id="posnetData" value="${this.paymentData.posnetData}">
          <input name="posnetData2" type="hidden" id="posnetData2" value="${this.paymentData.posnetData2}">
          <input name="mid" type="hidden" id="mid" value="${this.paymentData.mid}">
          <input name="posnetID" type="hidden" id="posnetID" value="${this.paymentData.posnetId}">
          <input name="digest" type="hidden" id="sign" value="${this.paymentData.digest}">
          <input name="merchantReturnURL" type="hidden" id="merchantReturnURL" value="${this.callbackUrl}">
          <input name="lang" type="hidden" id="lang" value="tr">
          <input name="url" type="hidden" id="url" value="${this.currentUrl}">
        </form>
        <script>
          setTimeout(() => {
              document.getElementById('posnetForm').submit();
          }, 333);
        <\/script>
      </div>
      `
    },
    locale() {
      return this.$i18n.locale
    },
    years() {
      const years = [
        this.$t('Year'),
      ]
      const currentYear = new Date().getFullYear()
      for (let i = 0; i < 10; i++) {
        years.push((currentYear + i).toString())
      }
      return years
    },
  },
  beforeRouteUpdate(to, from, next) {
    // Recreate the shared form when switching offers or package types.
    if (to.params.productId === MARKET_PRODUCT_ID || from.params.productId === MARKET_PRODUCT_ID) {
      next()
      this.$nextTick(() => {
        this.dynamicError = ''; this.product = null; this.mobileProduct = null; this.dynamicOffer = null
        this.creditCard.number = ''; this.creditCard.cvv = ''
        this.initializePurchase()
      })
      return
    }
    next()
  },
  beforeDestroy() {
    if (this.isDynamicMarket) { this.creditCard.number = ''; this.creditCard.cvv = '' }
  },
  mounted() {
    // new Card({
    //   form: "form#cc-form",
    //   container: ".card-wrapper",
    //   formSelectors: {
    //     numberInput: "input#number",
    //     expiryInput: "input#cc-expiration",
    //     cvcInput: "input#cvv",
    //     nameInput: "input#name"
    //   },
    //   formatting: true,
    //   placeholders: {
    //     number: "•••• •••• •••• ••••",
    //     name: "Ad Soyad",
    //     expiry: "••/••",
    //     cvc: "•••"
    //   }
    // })

    setTimeout(() => {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    }, 1000)
  },
  created() { this.initializePurchase() },
  methods: {
    initializePurchase() {
      // Purchase source'u localStorage'a ata
      this.purchaseSource = this.$route.params?.purchaseSource || (localStorage.getItem('PURCHASE_SOURCE') || null)
      if (this.purchaseSource) {
        localStorage.setItem('PURCHASE_SOURCE', this.purchaseSource)
      }

      this.productId = this.$route.params.productId
      this.dynamicOfferId = this.isDynamicMarket ? this.$route.query.marketOfferId : null
      this.couponCode = this.isDynamicMarket ? '' : this.$route.query.code || ''
      this.couponCodeBonusRatio = this.isDynamicMarket ? null : this.$route.query.ratio || ''
      this.campaignId = this.isDynamicMarket ? null : this.$route.query.campaignId || null
      this.campaignType = this.isDynamicMarket ? null : this.$route.query.campaignType || null

      if (this.isDynamicMarket) {
        this.purchaseSource = 'dynamic_market'
        localStorage.setItem('PURCHASE_SOURCE', this.purchaseSource)
        this.loadDynamicOffer()
      } else if (this.campaignId && (this.campaignType === 'ONE_TIME_OFFER')) {
        this.getProductOneTimeOffer()
      } else if (this.campaignType === 'BONUS_CREDITS') {
        this.getProductBonusCredits()
      } else {
        this.getProduct()
      }

      // Otomatik mevcut ay seçme açılırsa ay tek hane olduğunda başına '0' eklenecek
      // this.creditCard.month = (new Date().getMonth() + 1).toString()
      // this.creditCard.year = new Date().getFullYear().toString()

      // this.creditCard.month = this.$t('Month')
      // this.creditCard.year = this.$t('Year')

      const user = this.$store.getters['auth/user']

      this.creditCard.name = user.firstName || user.lastName ? `${user.firstName || ''} ${user.lastName || ''}` : ''
      this.creditCard.firstname = user.firstName || ''
      this.creditCard.lastname = user.lastName || ''
      this.creditCard.phone = user.phoneNumber || ''
      this.creditCard.email = user.email || ''

      this.mobilePayment.firstname = user.firstName || ''
      this.mobilePayment.lastname = user.lastName || ''
      this.mobilePayment.phone = user.phoneNumber || ''
      this.mobilePayment.email = user.email || ''
    },
    async loadDynamicOffer() {
      this.product = null; this.mobileProduct = null; this.dynamicOffer = null; this.dynamicError = ''; this.loading = true
      try {
        if (!validOfferId(this.dynamicOfferId)) throw new Error('invalid_offer')
        const requestedId = this.dynamicOfferId
        const offer = await dynamicMarket.status(requestedId)
        if (!this.isDynamicMarket || this.dynamicOfferId !== requestedId) return
        if (offer.offerId !== requestedId) throw new Error('invalid_offer')
        sessionStorage.setItem(`dynamic-market-offer:${this.$store.getters['auth/userId']}`, offer.offerId)
        if (!checkoutReady(offer)) {
          await this.$router.replace({ name: 'market-dynamic' })
          return
        }
        this.dynamicOffer = offer; this.product = productFromOffer(offer)
      } catch (error) { this.dynamicError = this.dynamicCopy.offline } finally { this.loading = false }
    },
    beginDynamicInit() {
      if (!this.isDynamicMarket) return true
      if (this.dynamicInitInFlight) return false
      if (!checkoutReady(this.dynamicOffer)) {
        this.dynamicError = this.dynamicCopy.offerExpired
        return false
      }
      this.dynamicInitInFlight = true
      return true
    },
    finishDynamicInit() {
      if (!this.isDynamicMarket) return
      this.dynamicInitInFlight = false
      this.creditCard.number = ''; this.creditCard.cvv = ''
    },
    currencySymbol(currency) {
      const code = String(currency || 'TRY').toUpperCase()
      return { TRY: '₺', USD: '$', EUR: '€' }[code] || code
    },
    numberFormatter,
    applyCouponCode() {
      if (this.isDynamicMarket) return
      this.$store.dispatch('payment/setLoading', true)

      useJwt.couponCodeCheckBeforePurchasing({ code: this.couponCode })
        .then(response => {
          const data = response.data.body

          if (data.valid) {
            this.minCredits = data.minCredits
            if (this.minCredits <= this.product.credits) {
              this.couponCodeBonusRatio = data.bonusRatio || this.couponCodeBonusRatio
              this.couponCodeSucceed = true
              this.couponCodeInfoColor = 'color-green'
              this.couponCodeInfoText = this.$t('Your {ratio} bonus coupon has been recognized. It will be credited to your account along with your diamonds after you make your payment.', { ratio: `%${(data.bonusRatio || this.couponCodeBonusRatio) * 100}` })
            } else {
              this.modalMinCreditsForProduct = true
              this.couponCode = ''
            }
          } else {
            this.couponCodeSucceed = false
            this.couponCodeInfoColor = 'color-red-light'
            this.couponCodeInfoText = this.$t('You entered an incorrect or invalid coupon code. Check your details and try again. In case of problems, contact Boho Assistant.')
          }
        })
        .catch(() => {
          this.couponCodeSucceed = false
          this.couponCodeInfoColor = 'color-red-light'
          this.couponCodeInfoText = this.$t('You entered an incorrect or invalid coupon code. Check your details and try again. In case of problems, contact Boho Assistant.')
        })
        .finally(() => { this.$store.dispatch('payment/setLoading', false) })
    },
    back() {
      this.$router.back()
    },
    buyWithCraftgate() {
      if (!this.beginDynamicInit()) return
      return this.$refs.formCraftgate.validate().then(success => {
        if (success) {
          this.loading = true

          const data = {
            productId: this.productId,
            campaignId: this.campaignId,
            couponCode: this.couponCode && this.couponCode !== '' ? this.couponCode : null,
            purchaseSource: this.purchaseSource,
          }
          if (this.isDynamicMarket) { delete data.campaignId; delete data.couponCode; data.marketOfferId = this.dynamicOfferId; data.termsAccepted = true }

          return useJwt.paymentCraftgateInit(data)
            .then(response => {
              try {
                if (this.isDynamicMarket) unwrapMarket(response)
                if (this.isDynamicMarket) { localStorage.removeItem('LAST_COUPON_CODE'); localStorage.removeItem('LAST_CAMPAIGN_ID'); this.$store.dispatch('payment/setPaymentHtml', null) }
                setTimeout(() => {
                  localStorage.setItem('LAST_PAYMENT_AMOUNT', response.data.body.amount || this.product.amount)
                  localStorage.setItem('LAST_PAYMENT_CURRENCY', response.data.body.currency || this.product.currency)
                  this.$store.dispatch('payment/setPaymentCraftgate', response.data.body)
                  this.$store.dispatch('payment/setStatus', true)
                }, 333)
              } catch (e) {
                if (this.isDynamicMarket) throw e
                throwDefaultError(this.$toast)
              }
            })
            .catch(error => {
              throwPaymentError(this.$toast, error)
              if (this.isDynamicMarket) this.loadDynamicOffer()
            })
            .finally(() => {
              this.loading = false
            })
        }
      }).finally(() => { this.finishDynamicInit() })
    },
    buyWithCreditCard() {
      if (!this.beginDynamicInit()) return
      return this.$refs.form.validate().then(success => {
        if (success) {
          this.loading = true

          // İsim ve soyisim ayırma işlemi
          let firstName = ''
          let lastName = ''

          if (this.purchaseSource) {
            localStorage.setItem('PURCHASE_SOURCE', this.purchaseSource)
          }

          if (this.creditCard.name) {
            const nameParts = this.creditCard.name.trim().split(' ')
            if (nameParts.length > 1) {
              // Son kelime soyadı, geri kalanı ad olarak kabul ediyoruz
              lastName = nameParts.pop() // Son kelimeyi al ve diziden çıkar
              firstName = nameParts.join(' ') // Geri kalan tüm kelimeleri birleştir
            } else {
              // Eğer tek kelime girilmişse, soyad olarak kabul ediyoruz
              // eslint-disable-next-line prefer-destructuring
              lastName = nameParts[0]
              firstName = ''
            }
          }

          const data = {
            creditCard: {
              cardNumber: this.creditCard.number.replace(/\s/g, '').replace(/-/g, ''),
              expiryMonth: this.creditCard.month,
              expiryYear: this.creditCard.year,
              cardCVV: this.creditCard.cvv,
            },
            email: this.creditCard.email,
            firstName: convertTrChars(firstName),
            lastName: convertTrChars(lastName),
            phoneNumber: this.creditCard.phone.replace(/\s/g, ''),
            productId: this.productId,
            campaignId: this.campaignId,
          }
          if (this.isDynamicMarket) { delete data.campaignId; data.marketOfferId = this.dynamicOfferId; data.termsAccepted = true }

          return useJwt.paymentPostnetInit(data)
            .then(response => {
              try {
                if (this.isDynamicMarket) unwrapMarket(response)
                if (this.isDynamicMarket) this.$store.dispatch('payment/setPaymentCraftgate', null)
                this.paymentData = response.data.body
                localStorage.setItem('LAST_PAYMENT_TRANSACTION_ID_KEY', this.paymentData.paymentTransactionId)
                localStorage.setItem('LAST_PAYMENT_AMOUNT', this.paymentData.amount || this.product.amount)
                localStorage.setItem('LAST_PAYMENT_CURRENCY', this.paymentData.currency || this.product.currency)

                if (this.couponCode) {
                  localStorage.setItem('LAST_COUPON_CODE', this.couponCode)
                } else {
                  localStorage.removeItem('LAST_COUPON_CODE')
                }

                if (this.campaignId) {
                  localStorage.setItem('LAST_CAMPAIGN_ID', this.campaignId)
                } else {
                  localStorage.removeItem('LAST_CAMPAIGN_ID')
                }
                setTimeout(() => {
                  // this.$refs.posnetForm.submit()
                  this.$store.dispatch('payment/setPaymentData', this.paymentData)
                  this.$store.dispatch('payment/setPaymentHtml', this.paymentHtml)
                  // this.$store.dispatch('payment/setLoading', true)
                  this.$store.dispatch('payment/setStatus', true)
                }, 333)
              } catch (e) {
                if (this.isDynamicMarket) throw e
                throwDefaultError(this.$toast)
              }
            })
            .catch(error => {
              throwPaymentError(this.$toast, error)
              if (this.isDynamicMarket) this.loadDynamicOffer()
            })
            .finally(() => {
              this.loading = false
            })
        }
      }).finally(() => { this.finishDynamicInit() })
    },
    buyMobilePurchase() {
      this.loading = true
      useJwt.paybymePurchase({ productId: this.mobileProduct.productId })
        .then(response => {
          try {
            const result = response.data.body
            if (result.status === 1) {
              this.redirectToPaybyme(result.errorDesc)
            }
          } catch (e) {
            throwDefaultError(this.$toast)
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    countryChanged(country) {
      this.country = country
    },
    detectCardType() {
      // Boşlukları kaldırıp sadece numaraları alıyoruz
      const cardNumber = this.creditCard.number.replace(/\s/g, '')

      // Minimum 2 karakter girilmeden algılama yapmıyoruz
      if (cardNumber.length < 2) {
        this.cardType = null
        return
      }

      // Visa kartları '4' ile başlar
      if (cardNumber.startsWith('4')) {
        this.cardType = 'visa'
        return
      }

      // Mastercard kartları '51', '52', '53', '54', '55' veya '2221' ile '2720' arasında başlar
      if ((cardNumber.startsWith('51')
              || cardNumber.startsWith('52')
              || cardNumber.startsWith('53')
              || cardNumber.startsWith('54')
              || cardNumber.startsWith('55'))
          || (cardNumber.length >= 4
              // eslint-disable-next-line radix
              && parseInt(cardNumber.substring(0, 4)) >= 2221
              // eslint-disable-next-line radix
              && parseInt(cardNumber.substring(0, 4)) <= 2720)
      ) {
        this.cardType = 'master'
        return
      }

      // Diğer durumlarda 'other' olarak işaretliyoruz
      // Eğer kart numarası en az 6 karakter girilmişse
      if (cardNumber.length >= 6) {
        this.cardType = 'other'
      } else {
        this.cardType = null // Henüz yeteri kadar karakter girilmemiş
      }
    },
    formatExpiryDate(value) {
      // Input event'inden gelen değer string olmalı
      if (typeof value !== 'string') {
        // eslint-disable-next-line no-param-reassign
        value = value.toString()
      }

      // Sadece rakamları alır, tüm diğer karakterleri (harfler dahil) yok sayar
      let numericValue = value.replace(/\D/g, '')

      // Eğer içerik değişmediyse gereksiz işlem yapmayalım
      if (numericValue === this.lastNumericValue) {
        return
      }
      this.lastNumericValue = numericValue

      // Ay kontrolü (ilk iki rakam)
      if (numericValue.length >= 1) {
        // İlk rakam 0 veya 1 olabilir
        if (numericValue[0] !== '0' && numericValue[0] !== '1') {
          numericValue = `0${numericValue.substring(1)}`
        }

        // İki rakam girildiğinde ay kontrolü
        if (numericValue.length >= 2) {
          const month = parseInt(numericValue.substring(0, 2), 10)

          // Ay 01-12 arasında olmalı
          if (month < 1) {
            numericValue = `01${numericValue.substring(2)}`
          } else if (month > 12) {
            numericValue = `12${numericValue.substring(2)}`
          }
        }
      }

      // 4 karakterden fazlasını kırp (AA/YY formatı için)
      if (numericValue.length > 4) {
        numericValue = numericValue.substring(0, 4)
      }

      // Yıl kontrolü (son iki rakam)
      if (numericValue.length >= 3) {
        const currentYear = new Date().getFullYear() % 100 // Son iki rakam
        const enteredYear = parseInt(numericValue.substring(2), 10) || 0

        // Eğer girilen yıl geçmiş bir yılsa, minimum olarak mevcut yılı ayarla
        if (numericValue.length === 4 && enteredYear < currentYear) {
          numericValue = numericValue.substring(0, 2) + currentYear.toString().padStart(2, '0')
        }
      }

      // AA/YY formatını oluştur
      if (numericValue.length > 2) {
        this.formattedExpiryDate = `${numericValue.substring(0, 2)}/${numericValue.substring(2)}`
      } else {
        this.formattedExpiryDate = numericValue
      }

      // Modeli güncelle
      this.creditCard.month = numericValue.substring(0, 2)
      this.creditCard.year = numericValue.substring(2, 4)
    },
    getProduct() {
      this.loading = true

      useJwt.getProducts()
        .then(response => {
          this.product = response.data.body.find(p => p.productId === this.productId)
          if (this.product) {
            this.mobileProduct = response.data.body.find(p => p.sku === this.product.sku && p.productId.includes('com.arasana.app.mobile.'))
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    getProductOneTimeOffer() {
      this.loading = true

      useJwt.checkOneTimeOffer({
        productId: this.productId,
        campaignId: this.campaignId,
      })
        .then(response => {
          this.product = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    getProductBonusCredits() {
      this.loading = true

      useJwt.checkBonusCredits({
        productId: this.productId,
        campaignId: this.campaignId,
      })
        .then(response => {
          this.product = response.data.body
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => { this.loading = false })
    },
    numberFormat,
    onDropdownOpen(open) {
      this.open = open
    },
    phoneValidate(status) {
      if (this.creditCard.phone !== '') {
        this.valid = status ? status.valid : false
      }
    },
    redirectToPaybyme(hash) {
      if (window) {
        if (sessionStorage) {
          const mobilePaymentOrder = {
            product: this.mobileProduct,
            transactionId: hash,
          }
          sessionStorage.setItem('arsnMobilePaymentOrder', JSON.stringify(mobilePaymentOrder))
        }

        window.location.href = `${this.paybymeRedirectUrl}?hash=${hash}`
      }
    },
    scrollTo(id) {
      const element = document.getElementById(id)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          })
        }, 200)
      }
    },
    validatePhoneInput(value) {
      // Sadece rakam, boşluk ve + işaretine izin ver
      const validValue = value.replace(/[^\d\s+]/g, '')

      // Eğer değer değiştiyse (yani geçersiz karakterler girildiyse), modeli güncelle
      if (validValue !== value) {
        this.$nextTick(() => {
          this.creditCard.phone = validValue
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
input {
  padding: 18px 16px !important;
  border-radius: 18px !important;
}
.market-banner-mobile {
  display: none;
  background: url("~@/assets/images/bg/market-banner-mobile-bg.png") no-repeat center center;
  padding: 16px 24px;
  border-radius: 12px;
  margin-bottom: 10px;

  .market-banner-mobile-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 8px 30px 8px 48px;
    border-radius: 12px;
    background-color: #fff;
    color: #EC065B;
    position: relative;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 600;

    img {
      position: absolute;
      left: -20px;
      top: -4px;
    }
  }

  @media (max-width: 767px) {
    display: block;
  }
}
.market-banner-desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: url("~@/assets/images/bg/market-banner-desktop-bg.png") no-repeat center center;
  background-size: cover;
  border-radius: 12px;
  padding: 16px;

  .market-banner-desktop-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 12px;
    border-radius: 12px;
    background-color: #fff;
    color: #000;
    position: relative;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 400;
    min-height: 220px;

    p {
      margin-bottom: 6px;
    }
  }

  .market-banner-desktop-footer {
    position: absolute;
    bottom: 16px;
    left: 8%;
    width: 84%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    padding: 12px;
    border-radius: 12px;
    background-color: #fff;

    a {
      color: #000;
      font-family: 'Inter', sans-serif;
      font-size: 11px;
      font-weight: 400;
      text-decoration: underline;
    }
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.font-inter {
  font-family: 'Inter', sans-serif !important;
}
.fs-16 {
  font-size: 16px !important;
}
.fs-14 {
  font-size: 14px !important;
}
.fs-11 {
  font-size: 11px !important;
}
.fw-500 {
  font-weight: 500 !important;
}
.fw-400 {
  font-weight: 400 !important;
}

.mobile-payment-details {
  font-family: 'Inter', sans-serif;
  font-weight: 400 !important;
  font-size: 14px;
  color: #000;
  .mobile-payment-details-item-value {
    padding: 8px 16px;
    border: 1px solid #D9D9D9;
    border-radius: 16px;
  }
}

.card-type-title {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #000;
}
.card-types {
  display: flex;
  justify-content: space-between;
  gap: 12px;

  div {
    padding-top: 6px;
    padding-bottom: 6px;
    width: 100%;
    border-radius: 12px;
    border: 1px solid #DBDBDB;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  .selected {
    background: #ece9e9;
  }
}
</style>

<style lang="scss">
.vs__dropdown-toggle {
  padding: 8px 4px !important;
  border-radius: 12px !important;
}
.page-market-buy {
  .phone-input {
    border: 1px solid #d8d6de !important;
    border-radius: 18px !important;
    padding: 2px !important;
    background: #fff !important;

    .vti__dropdown {
      margin: 4px;
      border-radius: 18px !important;
      background: #fff;
      text-align: center;
      padding: 0px;
      color: #000;
    }

    .vti__input {
      border-radius: 0 2px 2px 0;
      padding-left: 2px;
      background: rgba(0, 0, 0, 0);
    }
  }

  .vs__dropdown-toggle {
    padding: 2px 4px !important;
    border-radius: 18px !important;
  }
}
</style>

<style lang="scss">
/* =========================================================
   Ödeme sayfası — yeni koyu UI (sadece görünüm)
   Tüm kurallar .page-market-buy altında; form/akış koduna dokunulmadı.
   ========================================================= */
.page-market-buy {
  $mb-text: #f4f1ff;
  $mb-muted: rgba(226, 220, 255, 0.72);
  $mb-card: rgba(32, 22, 72, 0.72);
  $mb-border: rgba(150, 110, 255, 0.28);
  $mb-input: rgba(14, 10, 40, 0.55);

  color: $mb-text;

  .bank-account-heading {
    color: $mb-text;
  }

  .bank-account-card {
    background: $mb-card !important;
    border: 1px solid $mb-border;
    border-radius: 16px;
    min-height: 170px;

    .card-text {
      color: $mb-text;
      line-height: 1.8;
      overflow-wrap: anywhere;

      b { color: $mb-muted; }
    }
  }

  padding: 10px 28px 40px;

  @media (max-width: 991px) { padding: 8px 16px 32px; }
  @media (max-width: 575px) { padding: 6px 8px 24px; }

  /* ---------- Başlık ---------- */
  .back-button a {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(14, 10, 40, 0.6);
    border: 1px solid rgba(170, 140, 255, 0.35);
    transition: background .15s ease;

    &:hover { background: rgba(139, 92, 246, 0.3); }
  }

  .page-title {
    color: #fff !important;
    font-size: 26px;
    font-weight: 800;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    &::after {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #10b981;
      box-shadow: 0 0 10px rgba(16, 185, 129, 0.8);
    }
  }

  .h3 {
    color: #fff !important;
    font-size: 18px;
    font-weight: 700;
    margin: 6px 0 18px;
  }

  /* ---------- Seçilen paket özeti ---------- */
  .payment-package-details {
    width: 100%;
    margin-left: 0;
    padding: 18px 22px;
    border-radius: 18px;
    background: linear-gradient(135deg, #2b1a63 0%, #1d1247 50%, #3a1356 100%);
    border: 1px solid rgba(234, 3, 178, 0.35);
    box-shadow: 0 10px 30px rgba(6, 2, 24, 0.45), 0 0 18px rgba(234, 3, 178, 0.15);

    .package-left {
      width: 58px;
      height: 58px;
      border-radius: 16px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(251, 191, 36, 0.12);
      border: 1px solid rgba(251, 191, 36, 0.4);

      img { filter: drop-shadow(0 0 8px rgba(251, 191, 36, 0.6)); }
    }

    .package-right {
      .package-name {
        color: #fff;
        font-size: 19px;
        font-weight: 800;
        line-height: 26px;

        span {
          color: #fde68a;
          font-weight: 700;
        }
      }

      .package-description {
        color: $mb-muted;
        font-size: 13px;
        line-height: 18px;
        margin-top: 2px;
      }
    }
  }

  /* ---------- Ödeme yöntemi kartları ---------- */
  .buying-options .buying-option {
    position: relative;

    .buying-option-header {
      position: relative;
      background: $mb-card;
      border: 1px solid $mb-border;
      border-radius: 16px;
      padding: 16px 22px;
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      box-shadow: 0 8px 24px rgba(6, 2, 24, 0.35);
      transition: background .2s ease, border-color .2s ease;

      .color-gray {
        color: $mb-muted !important;
        margin-top: 2px;
      }

      &:hover { background: rgba(48, 32, 100, 0.8); }

      /* açık olan yöntem: menübardaki seçili sekmenin gradyanı */
      &.not-collapsed {
        background: linear-gradient(135deg, rgba(234, 3, 178, 0.28) 0%, rgba(168, 85, 247, 0.22) 50%, rgba(99, 102, 241, 0.12) 100%);
        border-color: rgba(234, 3, 178, 0.4);
        box-shadow: 0 2px 14px rgba(234, 3, 178, 0.18), inset 0 1px 1px rgba(255, 255, 255, 0.2);
      }

      .badge-advantage {
        top: -13px;
        padding: 5px 14px;
        border-radius: 9999px;
        font-size: 11px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: .3px;
        background: linear-gradient(135deg, #10b981, #22c55e);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.45);
      }
    }

    .buying-option-body {
      color: $mb-muted;
      margin-top: -28px;
      padding: 30px 18px 18px;
      border-radius: 0 0 18px 18px;
      background: rgba(20, 14, 50, 0.6);
      border: 1px solid rgba(150, 110, 255, 0.18);
      border-top: 0;

      @media (max-width: 575px) { padding: 26px 10px 14px; }
    }
  }

  /* ---------- Sol tanıtım kartı ---------- */
  .market-banner-desktop {
    position: relative;
    min-height: 360px;
    background: linear-gradient(160deg, #3b1a7a 0%, #1d1247 55%, #4a1257 100%) !important;
    border: 1px solid rgba(234, 3, 178, 0.35);
    border-radius: 18px;
    box-shadow: 0 0 22px rgba(234, 3, 178, 0.15);
    padding: 20px 16px 90px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      width: 240px;
      height: 240px;
      background: radial-gradient(circle, rgba(251, 191, 36, 0.25), transparent 65%);
      pointer-events: none;
    }

    > img {
      position: relative;
      max-width: 120px;
      filter: drop-shadow(0 8px 18px rgba(251, 191, 36, 0.45));
    }

    .market-banner-desktop-inner {
      background: rgba(14, 10, 40, 0.55);
      border: 1px solid rgba(170, 140, 255, 0.25);
      color: $mb-text;
      min-height: 0;
      width: 100%;
      margin-top: 12px;

      b { color: #fff; }

      span[style] {
        color: #fde68a !important;
        font-weight: 800;
      }
    }

    .market-banner-desktop-footer {
      background: rgba(14, 10, 40, 0.65);
      border: 1px solid rgba(170, 140, 255, 0.2);

      a {
        color: $mb-muted;

        &:hover { color: #fff; }
      }
    }
  }

  .market-banner-mobile {
    background: linear-gradient(135deg, #3b1a7a, #4a1257) !important;
    border: 1px solid rgba(234, 3, 178, 0.35);

    .market-banner-mobile-inner {
      background: rgba(14, 10, 40, 0.6);
      color: #fde68a;
    }
  }

  /* ---------- Form alanları ---------- */
  label,
  .col-form-label,
  .card-type-title {
    color: #fff !important;
    font-size: 13px;
    font-weight: 500;
  }

  .form-control,
  input.form-control,
  textarea.form-control {
    background: $mb-input !important;
    border: 1px solid rgba(170, 140, 255, 0.28) !important;
    color: #fff !important;
    box-shadow: none !important;

    &::placeholder { color: rgba(226, 220, 255, 0.45); }

    &:focus {
      border-color: #a855f7 !important;
      box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.2) !important;
    }

    &:disabled,
    &[readonly] {
      opacity: .8;
    }

    &.is-invalid { border-color: #fc668a !important; }
  }

  .input-group-append .btn {
    border-radius: 0 18px 18px 0 !important;
    font-weight: 700;
    background: linear-gradient(135deg, #10b981, #22c55e) !important;
    border: 0 !important;
  }

  .card-types {
    div {
      background: $mb-input;
      border-color: rgba(170, 140, 255, 0.28);
      border-radius: 14px;
      padding-top: 8px;
      padding-bottom: 8px;
      color: $mb-muted;
    }

    .selected {
      background: linear-gradient(135deg, rgba(234, 3, 178, 0.28) 0%, rgba(168, 85, 247, 0.22) 50%, rgba(99, 102, 241, 0.12) 100%);
      border-color: rgba(234, 3, 178, 0.45);
      color: #fff;
      box-shadow: 0 0 12px rgba(234, 3, 178, 0.2);
    }
  }

  .phone-input {
    background: $mb-input !important;
    border-color: rgba(170, 140, 255, 0.28) !important;

    .vti__dropdown {
      background: rgba(139, 92, 246, 0.2);
      color: #fff;
    }

    .vti__input { color: #fff; }
  }

  .vs__dropdown-toggle {
    background: $mb-input;
    border-color: rgba(170, 140, 255, 0.28);
  }

  .vs__selected,
  .vs__search { color: #fff; }

  .vs__dropdown-menu {
    background: #1e1648;
    border-color: rgba(170, 140, 255, 0.35);

    .vs__dropdown-option { color: #fff; }
    .vs__dropdown-option--highlight { background: rgba(139, 92, 246, 0.45); }
  }

  /* ---------- Toplam tutar ---------- */
  .mobile-payment-details {
    color: #fff;

    .mobile-payment-details-item-title { color: $mb-muted; }

    .mobile-payment-details-item-value {
      color: #fff;
      font-weight: 700;
      background: rgba(251, 191, 36, 0.08);
      border: 1px solid rgba(251, 191, 36, 0.4);
      border-radius: 14px;
    }
  }

  /* ---------- Satın al butonu ---------- */
  .btn-primary2 {
    position: relative;
    min-height: 52px;
    font-size: 17px;
    font-weight: 800;
    border-radius: 9999px;
    background: linear-gradient(135deg, #ff1f8f, #7c3aed) !important;
    box-shadow: 0 10px 24px rgba(255, 31, 143, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.25);
    transition: filter .15s ease, transform .15s ease;

    &:hover:not(:disabled) {
      opacity: 1;
      filter: brightness(1.1);
      transform: translateY(-1px);
    }

    &:disabled { opacity: .6; }
  }

  /* ---------- Yardımcı renk sınıfları (bu sayfada koyu zemine uyarla) ---------- */
  .color-black { color: $mb-text !important; }
  .color-gray,
  .color-gray-2 { color: $mb-muted !important; }

  svg path[fill="black"] { fill: #fff; }

  a.text-decoration-underline,
  .text-underline a { color: #f472b6; }
}
</style>
